import { useEffect, useRef } from 'react'

export function useInfiniteScroll(callback: () => void) {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleScroll = () => {
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 20) {
        callback()
      }
    }

    container.addEventListener('scroll', handleScroll)
    return () => container.removeEventListener('scroll', handleScroll)
  }, [callback])

  return containerRef
}
